
import React from 'react';
import AdminGuard from '@/components/auth/AdminGuard';
import AdminHeader from '@/components/layout/AdminHeader';
import CountryOrderManager from '@/components/admin/CountryOrderManager';
import NavigationSection from '@/components/upload/NavigationSection';

const CountryOrder = () => {
  return (
    <AdminGuard>
      <div className="min-h-screen bg-background">
        <AdminHeader />
        <main className="container mx-auto px-4 py-8">
          <NavigationSection />
          <h1 className="text-3xl font-bold mb-8">Manage Country Display Order</h1>
          <CountryOrderManager />
        </main>
      </div>
    </AdminGuard>
  );
};

export default CountryOrder;
